import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomSidePanel from "../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../components/button";
import * as gatewayNameActions from "../store/actions/gateway_name_list_actions";

export default function GatewayNameSidePanel({ show, gatewayNameData, loadingData, handleClose, action, GATEWAY_NAME_ACTIONS }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    const { gatewayName, description } = gatewayNameData || {};
    const tempFormData = {
      gatewayName,
      description,
    };
    setFormData(tempFormData);
  }, [gatewayNameData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (action === GATEWAY_NAME_ACTIONS.CREATE) {
      const payload = {
        data: {
          gatewayName: formData.gatewayName,
          description: formData.description,
        },
      };
      dispatch(gatewayNameActions.createGatewayNameRequest(payload));
    }

    if (action === GATEWAY_NAME_ACTIONS.EDIT) {
      const payload = {
        id: gatewayNameData._id,
        loadingData,
        data: {
          gatewayName: formData.gatewayName,
          description: formData.description,
        },
      };
      dispatch(gatewayNameActions.editGatewayNameRequest(payload));
    }

    handleClose();
  };

  const handleChange = (inputKey, inputValue) => {
    setFormData((prev) => {
      return {
        ...prev,
        [inputKey]: inputValue,
      };
    });
  };
  return (
    <CustomSidePanel
      title={action === GATEWAY_NAME_ACTIONS.EDIT ? "Edit Gateway Name" : action === GATEWAY_NAME_ACTIONS.CREATE ? "Create Gateway Name" : ""}
      show={show}
      moduleName="Gateway Name"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >

      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{action === GATEWAY_NAME_ACTIONS.EDIT ? "Edit Gateway Name" : action === GATEWAY_NAME_ACTIONS.CREATE ? "Create Gateway Name" : ""}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <FormDisplay {...{ formData, handleChange, handleClose, handleSubmit }} />
      </div>
    </CustomSidePanel>
  );
}

const FormDisplay = ({ formData, handleChange, handleClose, handleSubmit }) => {
  const formFields = {
    gatewayName: "gatewayName",
    description: "description",
  };
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Form.Group className="form-group">
        <label className="form-label text-gray-700">Gateway Name</label>
        <Form.Control type="text" value={formData?.[formFields.gatewayName] || ""} onChange={(e) => handleChange(formFields.gatewayName, e.target.value)} />
      </Form.Group>
      <Form.Group className="form-group" xs={6}>
        <label className="form-label text-gray-700">Description</label>
        <Form.Control as="textarea" rows={3} value={formData?.[formFields.description] || ""} onChange={(e) => handleChange(formFields.description, e.target.value)} />
      </Form.Group>

      <Form.Group className="d-flex gap-3 mt-10">
        <Button type="button" size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <BlueGradientButton size="sm" type="submit">
          Save
        </BlueGradientButton>
      </Form.Group>
    </Form>
  );
};
